import React, { useCallback, useMemo } from 'react';
import { AccommodationsConsoleWithHealth } from '../../AccommodationsConsole';
import { HotelSearchMapLayout } from '@shared/constants/accommodations';
import type { ScenarioConsoleProps, ScenarioConfig } from '../scenarios.types';
import type { TopBarConfig } from '@shared/types/Accommodations.types';
import { OtaListingEntry } from '../components/listing-entry/OtaListingEntry';
import type { ScenarioListingEntryProps } from '../components/listing-entry/ListingEntry.types';

type OtaConsoleProps = Readonly<
  ScenarioConsoleProps & {
    layout?: HotelSearchMapLayout;
  }
>;

const OTA_TOP_BAR: TopBarConfig = {
  searchForm: { dateRangeEnabled: true, occupancySelectorEnabled: true },
  showJoyLogo: true,
  showCloseButton: false,
  showTravelProductToggle: true,
};

export const OtaAccommodationsConsole = ({ eventHandle, eventName, onClose, selectedHotelId, layout = HotelSearchMapLayout.COMPACT }: OtaConsoleProps) => {
  const scenarioConfig = useMemo<ScenarioConfig>(() => ({ variant: 'ota', topBar: OTA_TOP_BAR, mapLayoutMode: layout }), [layout]);

  const renderListingEntry = useCallback((props: ScenarioListingEntryProps) => <OtaListingEntry {...props} />, []);

  return (
    <AccommodationsConsoleWithHealth
      eventHandle={eventHandle}
      eventName={eventName}
      onClose={onClose}
      selectedHotelId={selectedHotelId}
      scenarioConfig={scenarioConfig}
      renderListingEntry={renderListingEntry}
    />
  );
};
